import { trpc } from '@/shared/api/trpc';

// Wraps `itineraries.update` for the view-tabs' lock toggle. Owns
// the byId invalidation on settle. The component layer fires
// success/error toasts off `mutation.data` / `mutation.error` per
// the architecture doc — no toast/router imports here.
export const useToggleLock = (args: { itineraryId: string | null }) => {
  const utils = trpc.useUtils();
  return trpc.itineraries.update.useMutation({
    onSettled: () => {
      if (args.itineraryId) {
        utils.itineraries.byId.invalidate({
          id: args.itineraryId,
          includeSubitems: true,
        });
      }
    },
  });
};
